<template>
    <div>
        <el-form :inline="true">
            <el-form-item label="门店：">
                <tenantSelector size="small" ref="tenantSelector" v-model="filters.tenant" />
            </el-form-item>
            <el-form-item label="日期：">
                <dateOptionSelector size="small" v-model="filters.dateTime" ref="dateOptionSelector"
                    :options="dateOptions" />
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="queryAll">查询</el-button>
            </el-form-item>
        </el-form>
        <el-tabs v-model="filters.type" type="border-card" @tab-click="activeChange">
            <el-tab-pane v-for="tab in tabs" :key="tab.key" :name="tab.key" :label="tab.name">
            </el-tab-pane>
        </el-tabs>
        <div class="tab-content">
            <!--列表-->
            <el-table size="mini" stripe border :data="rows" highlight-current-row expand-on-click-node="false"
                style="width: 100%">
                <el-table-column sortable v-for="column in columns"  :key="column.value" :prop="column.value" :label="column.name" />
            </el-table>
        </div>
    </div>
</template>
<script>
import { report } from "@/api/analysis.js";
import dateOptionSelector from "@/components/dateOptionSelector"
import tenantSelector from "@/components/tenantSelector"
export default {
    components: {
        tenantSelector,
        dateOptionSelector,
    },
    data() {
        return {
            tabs: [
                { key: "detail", name: "明细" },
                { key: "saler", name: "销售" },
                { key: "product", name: "产品" },
                { key: "car", name: "车型" }
            ],
            dateOptions: [{ value: "create", name: "开单时间" }],
            filters: {
                type: "detail",
                tenant: "",
                dateTime: {
                    dateType: "create",
                    date: [],
                }
            },
            rows: [],
            columns: [],
        };
    },
    methods: {
        queryAll() {
            if (!this.filters.dateTime || !this.filters.dateTime.date.length) {
                this.msg.errorMsg("请选择统计时间");
                return;
            }
            let para = {
                type: this.filters.type,
                tenant: this.filters.tenant ? this.filters.tenant.Key : "",
                dateType: this.filters.dateTime.dateType,
                beginDate:
                    this.filters.dateTime.date.length > 0
                        ? this.filters.dateTime.date[0]
                        : "",
                endDate:
                    this.filters.dateTime.date.length > 1
                        ? this.filters.dateTime.date[1]
                        : "",
            };
            report(para).then((response) => {
                if (response) {
                    this.rows = response.rows;
                    this.columns = response.columns;
                }
            });
        },
        activeChange() {
            this.queryAll();
        },
    },
    mounted() {
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        const end = new Date();
        this.filters.dateTime.date = [start, end];
        setTimeout(() => {
            this.queryAll();
        }, 1000);
    },
};
</script>
<style lang='scss'  scoped>
/deep/.el-tabs--border-card>.el-tabs__content {
    padding: 0;
    height: 1px;
}

.tab-content {
    margin-top: -2px;
    border: 1px solid #dcdfe6;
    border-top: 0;
    padding: 15px;
    background: #fff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
}

.row-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-self: center;
}

/deep/.el-form-item {
    margin-bottom: 10px;
}

/deep/.el-drawer__header {
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: bold;
    color: #ff862f;
}

/deep/.el-drawer__body {
    overflow-y: scroll;
}
</style>